import { Helmet } from "react-helmet-async"
import { Navigate } from "../../../../../router"
import useFolderDetailsOutletContext from "./_folder-details-context"
import { FolderDetails } from "../../../../../DataDrive/List"
import { generatePath } from "../../../../../router-utils"
import { Breadcrumbs } from "@sembark-travel/ui/router"

export default function FolderPage() {
	const { folderDetails, refreshFolderDetails } =
		useFolderDetailsOutletContext()

	if (folderDetails.files.length)
		return (
			<Navigate
				to={`/data-drive/folders/:folderId/files/:fileId`}
				params={{
					folderId: String(folderDetails.id),
					fileId: String(folderDetails.files[0].id),
				}}
			/>
		)
	return (
		<>
			<Helmet>
				<title>Data Drive Folder</title>
			</Helmet>
			<Breadcrumbs
				title={folderDetails.name}
				items={[[generatePath("/data-drive"), "Data Drive"]]}
			/>
			<FolderDetails
				folderDetails={folderDetails}
				refreshFolderDetails={refreshFolderDetails}
			/>
		</>
	)
}
